export default function yesOrNo(value) {
    switch (value) {
        case true:
            return 'Yes';
        case false:
            return 'No';
        default:
            return '';
    }
}
